import { IFormulationNav } from '../../types/formulation/shared/FormulationNav.type';

export const FormulationNavValues = {
    formulationNav: { formulaTotals: null } as IFormulationNav,
};
